import _get from 'lodash/get';

import {
  AI_GENERATION_TYPE,
  APPROVAL_RESPONSE_TYPE,
  AUTOMATIC_RESPONSE_TYPE,
  MANUAL_RESPONSE_TYPE,
  TEMPLATE_GENERATION_TYPE,
} from '../../../../../business-profile/components/ResponseSettingsForm/ResponseSettingsForm.constants';

const DEFAULT_DELAY_UNIT = 'DAYS';
const DEFAULT_DELAY_AMOUNT = 1;

export function getInfoText(reviewResponse, delayUnit, delayAmount) {
  const reviewResponseType = _get(reviewResponse, 'metadata.type', MANUAL_RESPONSE_TYPE);
  const reviewResponseGenerator = _get(
    reviewResponse,
    'metadata.generator',
    TEMPLATE_GENERATION_TYPE,
  );

  if (reviewResponseType === AUTOMATIC_RESPONSE_TYPE) {
    if (reviewResponseGenerator === AI_GENERATION_TYPE) {
      return `This response was created by your assistant and will be automatically posted after ${delayAmount} ${delayUnit}.`;
    }

    if (reviewResponseGenerator === TEMPLATE_GENERATION_TYPE) {
      return `This response was created from your template and will be automatically posted after ${delayAmount} ${delayUnit}.`;
    }
  }

  if (reviewResponseType === APPROVAL_RESPONSE_TYPE) {
    if (reviewResponseGenerator === AI_GENERATION_TYPE) {
      return `This response was created by your assistant. Your approval is required to submit.`;
    }

    if (reviewResponseGenerator === TEMPLATE_GENERATION_TYPE) {
      return `This response was created from your template. Your approval is required to submit.`;
    }
  }

  return null;
}

export function getDelayUnit(reviewResponse) {
  const delayUnit = _get(reviewResponse, 'metadata.delay.unit', DEFAULT_DELAY_UNIT);
  return delayUnit.toLowerCase();
}

export function getDelayAmount(reviewResponse) {
  return _get(reviewResponse, 'metadata.delay.quantity', DEFAULT_DELAY_AMOUNT);
}

export function getApprovedByEmail(reviewResponse) {
  return _get(reviewResponse, 'approved_by.email');
}
